import { Component } from 'react';
import { API_ENDPOINT } from '../../../constants';
import ListBuilder from '../../../components/listBuilder';
import {
    updateParamsHelper,
    getParamsFromURL,
} from '../../../helpers/custom.helper';
import PreviewModal from '../../../components/previewModal';

export default class PatientPreviousRecordsTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: false,
            preview: false,
            total: 0,
            params: {
                entries: 10,
                page: 0,
                sortField: 'tsCreatedAt',
                sortType: -1,
                filter: '',
            },
            filter: null,
            loading: true,
            previousRecords: [],
            error: null,
            modified: 'Not modified'.translate(this.props.lang),
            isConsentActive: false,
        };
    }

    get = async () => {
        this.setState({
            loading: true,
            previousRecords: [],
            modified: 'Not modified'.translate(this.props.lang),
        });

        try {
            // fetch(API_ENDPOINT + `/users/users/patient/journal-system/has-consent/${this.props.patientId}/${this.props._groupId}`, {
            // 	method: 'GET',
            // 	headers: {
            // 		'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
            // 		'content-type': 'application/json'
            // 	},
            // }).then(res => res.json()).then((result) => {
            // 	if (result.success) {
            // 		this.setState({
            // 			isConsentActive: true
            // 		})
            // 	} else {
            // 		this.setState({
            // 			isConsentActive: false
            // 		})
            // 	}
            // })

            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/patientPreviousRecords/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupAlias: localStorage.getItem('groupAlias'),
                        groupId: this.props._groupId || null,
                        patientId: this.props.patientId,
                        total: this.state.total,
                        entries: this.state.params?.entries,
                        page: this.state.params?.page,
                        sortField: this.state.params?.sortField,
                        sortType: this.state.params?.sortType,
                        filter: this.state.params?.filter,
                        isConsentGrantedAndActive: this.props.isConsentGrantedAndActive
                    }),
                }
            );

            const resData = await response.json();
            const data = resData?.data || null;

            if (data?.items) {
                const newState = {
                    loading: false,
                    previousRecords: data?.items,
                    total: data?.total,
                };

                if (data.tsModified) {
                    const modified = this.props.getStringDateTs?.(
                        data?.tsModified,
                        this.props?.dateFormat
                    );
                    if (modified) newState.modified = modified.translate(this.props.lang);
                }

                this.setState(newState);
            } else {
                const errState = {
                    loading: false,
                    modified: 'Not modified'.translate(this.props.lang),
                };

                if (data.error) {
                    errState.error = data.error;
                }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || 'Error fetching previous records',
            });
        }
    };

    componentDidMount() {
        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams }, () => {
            if (this.props.previousRecords) {
                this.setState({
                    loading: false,
                    previousRecords: this.props.previousRecords,
                });
            } else {
                this.get();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.patientId !== this.props.patientId ||
            prevProps._groupId !== this.props._groupId ||
            prevProps.view !== this.props.view
        ) {
            this.setState({
                loading: true,
                previousRecords: [],
                modified: 'Not modified'.translate(this.props.lang),
            });

            this.get();
        }

        if (this.props.isConsentGrantedAndActive !== prevProps.isConsentGrantedAndActive) {
            this.get();
        }
    }

    // always copy - paste these updateSort, updateParams, updateMultipleParams
    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };

    render() {
        let params = this.state.params;

        return (
            <>
                <div className='panel-header'>
                    <h5 className='component-header'>
                        {'Previous Records'.translate(this.props.lang)}
                    </h5>
                </div>

                <ListBuilder
                    lang={this.props.lang}
                    loading={this.state.loading}
                    total={this.state.total}
                    hideEntries={false}
                    showNumeration={false}
                    // hideFilters={true}
                    fields={[

                        {
                            type: 'text',
                            name: 'metadata',
                            label: 'Notes'.translate(this.props.lang),
                        },

                    ]}
                    items={this.state?.previousRecords?.map((item) => {
                        return {
                            ...item,
                            ___className: item?.isDeleted ? 'journal-tab-item-delete' : '',
                            metadata: (
                                <div>
                                    <div key={item._id}>
                                        <p>{item?.metadata}</p>

                                        {item?.data?.map((dataItem, index) => (
                                            <div key={index} style={{ marginTop: '10px' }}>
                                                <div style={{ fontWeight: '600' }}>{dataItem?.title}</div>
                                                <div>{dataItem?.value}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        };
                    })}
                    actions={this.props.isConsentGrantedAndActive && this.state.isConsentActive ? [] : [
                        {
                            renderComponent: (item) =>
                                item?.isDeleted ? (
                                    <div className="deleted-badge">
                                        {'Deleted'.translate(this.props.lang)}
                                    </div>
                                ) : null,
                            onClick: (item) => { },
                        },
                        // {
                        // 	component: (
                        // 		<div className='tabel-action-tooltip'>
                        // 			{' '}
                        // 			<Isvg src={infoIcon} className='journal-info-icon' />
                        // 			<div className='chat-icons-tooltip'>
                        // 				{'Notes'.translate(this.props.lang)}
                        // 			</div>{' '}
                        // 		</div>
                        // 	),
                        // 	onClick: (item) => {
                        // 		this.setState({ preview: item });
                        // 	},
                        // },
                    ]}
                    rawItems={this.state.items}
                    params={params}
                    sortField={params.sortField}
                    sortType={params.sortType}
                    updateSort={this.updateSort}
                    updateParams={this.updateParams}
                    updateMultipleParams={this.updateMultipleParams}
                ></ListBuilder>

                {/* Preview */}
                <PreviewModal
                    lang={this.props.lang}
                    isOpen={this.state.preview}
                    toggle={() => this.setState({ preview: false })}
                    title={'Notes'.translate(this.props.lang)}
                >
                    {this.state.preview?.notes || "-"}
                </PreviewModal>
            </>
        );
    }
}
